export const rootPath = ''
export const baseUrl = `${window.location.origin}/${rootPath}`
